import MediaQuery from '../../js/lib/mediaQuery';

var submitButtons = document.querySelectorAll('input[type=submit]');
if (submitButtons) {
	for (var x = 0; x < submitButtons.length; x++) {
		var button = submitButtons[x];

		button.addEventListener('click', function () {
			var loadingIcon = document.createElement('i');
			loadingIcon.classList.add('icon-spin4', 'animate-spin');
			loadingIcon.style.fontSize = '4rem';
			button.parentElement.appendChild(loadingIcon);
			button.style.display = 'none';
			if (button.getAttribute('data-animate') != 'false')
				setTimeout(hideAfterTimeout.bind(button, button.id), 5000);
			else
				setTimeout(hideAfterTimeout.bind(button, button.id), 20000);
		});
	}
}


function hideAfterTimeout(id) {
	var inputButton = document.getElementById(id);
	inputButton.style.display = 'inline-block';
	var icon = inputButton.parentElement.getElementsByClassName('icon-spin4 animate-spin')[0];
	inputButton.parentElement.removeChild(icon);
}

//function showList(ul, start, end, cl)
//{
//    if (ul.children.length > 3) {
//        for (var x = start; x < ul.children.length - end; x++) {
//            ul.children[x].style.display = 'none';
//        }
//        var newItem = document.createElement("LI");
//        var newAnchor = document.createElement("a");// Create a <li> node
//        newAnchor.href = "javascript:void(0)";
//        var textnode = document.createTextNode("...");  // Create a text node
//        newAnchor.appendChild(textnode);
//		if(cl)
//			newAnchor.classList.add(cl);
		
//        newAnchor.addEventListener("click", function () {
//            for (var x = start; x < ul.children.length - end; x++) {
//                ul.children[x].style.display = 'inline-block';
//            }
//            this.parentElement.style.display = 'none';
//        });
//        newItem.appendChild(newAnchor);

//        // Add ellipsis node before last hidden element
//        ul.insertBefore(newItem, ul.children[start]);
//    }
//}

//if (footerElement) {
//	const footerToggle = document.querySelectorAll('.js-footer-toggle');
//	const closeFooterLists = () => {
//		for (var i = 0; i < footerToggle.length; i++) {
//			footerToggle[i].removeAttribute('open');
//		}
//	}

//	const toggleFooterList = (event) => {
//		let listToToggle = event.currentTarget;
//		if (!listToToggle.getAttribute('open')) {
//			closeFooterLists();
//			listToToggle.setAttribute('open', true);
//		} else {
//			closeFooterLists();
//		}
//	}

//	// Only if Mobile
//	const mediaQuery = new MediaQuery(function() {
//		for (var i = 0; i < footerToggle.length; i++) {
//			footerToggle[i].addEventListener('click', () => {
//				toggleFooterList(event);
//			});
//		}
//	}, 'mobile')
//	mediaQuery()

//	var uc = true
//	window.addEventListener("resize", ()=>{mediaQuery()});

//}



// WEBPACK FOOTER //
// ../components/submit-animation/submit-animation.js